<div class="bg-th-blue mt-0 container-fluid py-2">
    <div class=" d-flex justify-content-between align-content-center">
        <i class="fa fa-arrow-left text-secondary my-auto pointer text-white" routerLink="/"></i>
        <a class=" d-flex align-items-center  text-secondary f18 my-auto text-white">
            <span>CAN تحلیل اطلاعات</span>
        </a>
    </div>
</div>
<main class="px-2">
    <div class="container-fluid row gx-0 gy-2 mt-3 p-2">
        <div class="col-10 p-1">
            <input class="w-100 form-control" placeholder="جستجو کنید ..." (input)="filterResult($event.target.value)">
        </div>
        <div class="col-auto p-1">
            <button class="w-100 h-100 btn btn-success" (click)="exportExcel()">
                &nbsp; خروجی اکسل &nbsp;
            </button>
        </div>
        <div class="col-auto p-1 selected-item">
            <ng-container *ngFor="let item of systemStatus">
                <div class="custom-option-wrapper">
                    <label class="custom-checkbox-label">
                        <input type="checkbox" [checked]="hasStatusChecked(item)"
                            (change)="onCheckboxChange(item, $event)" />
                        <span class="option-text">{{ item.label }}</span>
                    </label>
                </div>
            </ng-container>
        </div>
        <div class="section border border-2 mt-2">
            <table class="col-12 table table-striped rounded-3" id="Export_Excel">
                <thead>
                    <tr class="text-center">
                        <th scope="col" class="">#</th>
                        <th scope="col" *ngFor="let header of tableData?.header">
                            {{header}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="f14 text-center" *ngFor="let row of tableData?.rows;let i=index">
                        <th> {{ i + 1 | faNum }}</th>
                        <td *ngFor="let value of row">
                            {{value | faNum}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</main>